import { gql } from "@apollo/client";

const Fragments = {
  bulkPrintingOffer: gql`
    fragment bulkPrintingOffer on BulkPrintingOffer {
      offerId
      offerSiteId
      offerNumber
      clientName
      contractNumbers
      offerDate
      offerStateName
    }
  `
};

export default Fragments;
